<template>
  <router-link tag="li" class="nav-item nav-dropdown " :to="url" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i :class="classIcon"></i> {{name}}</div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },

  computed: {
    classIcon() {
      return [
        'fa',
        'mr-2',
        'nav-icon',
        this.icon
      ]
    }
  },
  methods: {
    handleClick(e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
      // console.log(e);
    }
  }
}

</script>
<style scoped lang="css">
.nav-link {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarNavDropdown.vue